// XPEN-3792: who may delete expenses from a report, as the API decides it.
// Before submission (Pending) the report's people delete as before. Once submitted, the
// accounting team's correction action does, until the report is finalized. The API also
// lets an owner delete an expense whose line was denied, from the approval window.
import AccessControl from './access_control';

export const canDeleteReportExpenses = (account, data) => {
  const status = account?.status;
  if (status === 'Pending') return true;
  if (!status || status === 'Finalized') return false;
  return AccessControl.userCanCorrectValidatedExpenses(data);
};

// The translation key for a refused deletion, or the generic saving error.
export const reportExpenseDeletionErrorKey = (error) => {
  const code = error?.response?.data?.error;
  if (code === 'expense_deletion_forbidden') return 'report_expense_deletion.forbidden';
  if (code === 'expense_account_locked') return 'report_expense_deletion.locked';
  return 'internal_saving_error';
};
